<template>
  <div class="app">
    <transition name="fade">
      <v-loading v-if="isLoading"></v-loading>
    </transition>

  	<v-header :class="{'navBarWrap':navBarFixed}"></v-header>

    <el-row type="flex" justify="center" id="content">
  		<el-col :xs="20" :md="20" :style="{'minHeight':minHeight+'px'}">
  			<router-view></router-view>
  		</el-col>
  	</el-row>

    <v-footer></v-footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
  	return{
  		minHeight: 0,
      navBarFixed: false,
      isLoading: true
  	};
  },
  components: {
  },  
  methods: {
  	watchScroll () {
  		var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //  当滚动超过 50 时，实现吸顶效果
        if (scrollTop > 50) {
          this.navBarFixed = true
        } else {
          this.navBarFixed = false
        }
    },
    loadPageData: function() {
          // axios 请求页面数据 .then 中将状态值修改  
        this.isLoading = false
    },
  },
  mounted () {
  		let that = this
  		that.minHeight = document.documentElement.clientHeight
  		window.addEventListener('scroll', that.watchScroll)
  		window.onresize = function () {
  			that.minHeight = document.documentElement.clientHeight
      }
      // 初始化页面数据
      that.loadPageData()
    
  	}
}

</script>

<style scoped>
	/* .navBarWrap {
    position:fixed;
    top:0;
    z-index:999;
    width: 100%;
  } */

</style>




// WEBPACK FOOTER //
// src/App.vue